import { render } from "./AccountRegistrationRoleDetail.vue?vue&type=template&id=55acdc17&scoped=true"
import script from "./AccountRegistrationRoleDetail.vue?vue&type=script&lang=js"
export * from "./AccountRegistrationRoleDetail.vue?vue&type=script&lang=js"

import "./AccountRegistrationRoleDetail.vue?vue&type=style&index=0&id=55acdc17&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55acdc17"]])

export default __exports__